<template>
  <div class="account-info">
    <div class="contact-item border">
      <account-avatar :account="account" />
      <div class="contact-item-content">
        <div class="contact-item-content-name">
          <span>{{ nickName }}</span>
          <span role="img" tabindex="-1" :class="gender">
            <svg class="iconpark-icon"  width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
              <use :href="'#' + gender"></use>
            </svg>
          </span>
        </div>
        <div class="contact-item-content-msg">
          <div class="contact-item-content-msg-body">IM账号：{{ account.im_accid }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccountAvatar from '../../AccountAvatar.vue'
export default {
  name: 'AccountInfo',
  props: {
    account: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { AccountAvatar },
  computed: {
    nickName () {
      return this.account.im_name ? this.account.im_name : this.account.nick
    },
    gender () {
      if (this.account.im_gender === 1) return 'male'
      if (this.account.im_gender === 2) return 'female'

      return ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.account-info {
  padding: 10px;
}
.contact-item {
  display: flex;
  font-size: 14px;
  color: #333;
  padding: 12px;
  position: relative;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
  gap: 5px;
}
.contact-item-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 6px 0 10px;
  flex: 1;
  min-width: 0;
  line-height: normal;
}
.contact-item-content-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.male {
  color: #4d84fe;
}
.female {
  color: #fb7373;
}
.contact-item-content-msg {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.contact-item-content-msg-body {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.border {
  border-bottom: 1px solid #ded9d9;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/AccountInfo.vue